import axios from 'axios';
/** Services Import */
import CryptoJS from 'crypto-js';
import Store from '../../Store/Store';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import { showSnackbar } from '../../Reducer/SnackbarReducer';
import { showErrorDialog } from '../../Reducer/ErrorDialogReducer';

const Commons = {
  TypeSuccess: () => {
    return 'Success';
  },
  TypeError: () => {
    return 'Error';
  },
  TypeInfo: () => {
    return 'Info';
  },

  // 현재 화면의 너비와 높이 반환 함수
  Dimentions: () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  },

  // 모바일인지 Check, mobile => true
  IsMobile: () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  DeviceCheck: () => {
    const ua = navigator.userAgent;

    const isTablet =
      /iPad|Tablet|PlayBook|Silk/i.test(ua) ||
      (/Android/i.test(ua) && !/Mobile/i.test(ua)); // Android Tablet 구분

    const isMobile =
      /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry/i.test(ua);

    if (isTablet) return '0';
    if (isMobile) return '1';
    return '2';
  },

  // Android 인지 IOS 인지 구분
  CheckMobileDevice: () => {
    let varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf('android') > -1) {
      //안드로이드
      return 'android';
    } else if (
      varUA.indexOf('iphone') > -1 ||
      varUA.indexOf('ipad') > -1 ||
      varUA.indexOf('ipod') > -1
    ) {
      //IOS
      return 'ios';
    } else {
      //아이폰, 안드로이드 외 (web 화면 등)
      return 'other';
    }
  },

  // String change function
  ChangeString: (_data, _type = 'trim') => {
    if (_data.lenght < 1) {
      return '';
    }

    const data = _data.toString();

    switch (_type) {
      case 'trim':
        return data.trim();
      case 'lTrim':
        return data.trimStart();
      case 'rTrim':
        return data.trimEnd();
      case 'toInt':
        if (!parseInt(data)) {
          return 0;
        } else {
          return parseInt(data);
        }
      case 'toFloat':
        if (!parseFloat(data)) {
          return 0;
        } else {
          return parseFloat(data);
        }
      case 'upper':
        return data.toUpperCase();
      case 'lower':
        return data.toLowerCase();
    }
  },

  // Grid insert rows number
  InsertNumber: (_arr = []) => {
    let newArr = [];
    if (_arr.length > 0) {
      _arr.forEach((item, index) => {
        newArr.push({
          ...item,
          no: index + 1,
        });
      });

      return newArr;
    } else {
      return false;
    }
  },

  // 칼럼 'i' 기준으로 중복 제거
  Deduplication: (_arr = []) => {
    let result = _arr.reverse().filter((item, index) => {
      return (
        _arr.findIndex((item1, index1) => {
          return item.i === item1.i;
        }) == index
      );
    });

    return result.reverse();
  },
  // 칼럼 'no' 기준으로 중복 제거
  Deduplication2: (_arr = []) => {
    let result = _arr.reverse().filter((item, index) => {
      return (
        _arr.findIndex((item1, index1) => {
          console.log('item1', item1);
          return item.no === item1.no;
        }) == index
      );
    });

    return result.reverse();
  },
  // SHA256 암호화 함수
  Sha256Encrypt: (text) => {
    const hash = CryptoJS.SHA256(text);
    return CryptoJS.enc.Base64.stringify(hash);
  },

  // AES256 암호화 함수 - 모든 타입 지원 (숫자, boolean, 객체, 배열, 문자열 등)
  EncryptAES: (_value) => {
    // null이나 undefined 처리
    if (_value === null || _value === undefined) {
      return Commons.EncryptAES(JSON.stringify(null));
    }

    // 값과 타입 정보를 포함한 객체로 직렬화
    const dataToEncrypt = JSON.stringify({
      _type: typeof _value,
      _value: _value,
    });

    const cipher = CryptoJS.AES.encrypt(
      dataToEncrypt,
      CryptoJS.enc.Utf8.parse(
        process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, ' ')
      ),
      {
        iv: CryptoJS.enc.Utf8.parse(''),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return cipher.toString();
  },

  // AES256 복호화 함수 - 원본 타입으로 복원
  DecryptoAES: (_text) => {
    try {
      const cipher = CryptoJS.AES.decrypt(
        _text,
        CryptoJS.enc.Utf8.parse(
          process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, ' ')
        ),
        {
          iv: CryptoJS.enc.Utf8.parse(''),
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC,
        }
      );
      const decryptedText = cipher.toString(CryptoJS.enc.Utf8);

      // 빈 문자열이면 그대로 반환 (복호화 실패)
      if (!decryptedText) {
        return '';
      }

      try {
        // JSON 파싱 시도
        const parsed = JSON.parse(decryptedText);

        // 타입 정보가 포함된 객체인지 확인 (새 버전)
        if (
          parsed &&
          typeof parsed === 'object' &&
          '_type' in parsed &&
          '_value' in parsed
        ) {
          // 원본 타입으로 변환하여 반환
          const originalType = parsed._type;
          const originalValue = parsed._value;

          // 타입에 따라 적절히 변환
          switch (originalType) {
            case 'number':
              return typeof originalValue === 'string'
                ? parseFloat(originalValue)
                : originalValue;
            case 'boolean':
              return typeof originalValue === 'string'
                ? originalValue === 'true'
                : originalValue;
            case 'object':
              // null 처리
              if (originalValue === null) return null;
              // 배열이나 객체는 그대로 반환
              return originalValue;
            case 'string':
            default:
              return originalValue;
          }
        } else {
          // 기존 형식 (타입 정보가 없는 경우) - 문자열로 반환하여 하위 호환성 유지
          return typeof parsed === 'string' ? parsed : decryptedText;
        }
      } catch (parseError) {
        // JSON 파싱 실패 시 원본 문자열 반환 (기존 동작 유지)
        return decryptedText;
      }
    } catch (error) {
      // 복호화 실패 시 빈 문자열 반환
      console.error('DecryptAES error:', error);
      return '';
    }
  },

  // Local Storage get/set/remove/clear return function
  Storages: (_type, _name, _data) => {
    switch (_type) {
      case 'get':
        if (_name) {
          return JSON.parse(window.localStorage.getItem(_name));
        } else {
          return 'error';
        }
      case 'set':
        if (_name && _data) {
          window.localStorage.setItem(_name, JSON.stringify(_data));
          break;
        } else {
          return 'error';
        }
      case 'remove':
        if (_name) {
          window.localStorage.removeItem(_name);
          break;
        } else {
          return 'error';
        }
      case 'clear':
        window.localStorage.clear();
        break;
    }
  },

  //Axios get/post response function
  // _opts.suppressGlobalError: 전역 스낵바 없이 원본 axios 에러 throw (화면에서 직접 처리)
  Axios: async (_type = 'get', _url, _params, _bodys = null, _opts = {}) => {
    const state = Store.getState();
    const userInfo = state?.BaseInfo?.userInfo;

    const token = userInfo?.token ?? null;
    const userId = userInfo?.userid ?? null;

    // 공통 에러 처리 함수 (전역으로 에러 처리)
    const handleAxiosError = async (error, config) => {
      // 에러 분류
      const errorInfo = ErrorHandler.classifyError(error, config);

      // 개발자에게 메일 전송 (401은 제외 - 너무 빈번할 수 있음)
      if (errorInfo.type !== 'AUTH_ERROR') {
        if (error.stack) {
          errorInfo.stack = error.stack;
        }
        // await ErrorHandler.sendErrorEmailToDeveloper(errorInfo, config);
      }

      // 전역으로 에러 처리 (Redux 직접 dispatch)
      if (errorInfo.type === 'AUTH_ERROR') {
        // 401 에러는 전역 다이얼로그 표시
        Store.dispatch(
          showErrorDialog({
            title: '세션 만료',
            message: errorInfo.userMessage,
            type: 'auth',
            showLoginButton: true,
          })
        );
      } else {
        // 기타 에러는 스낵바로 표시
        Store.dispatch(
          showSnackbar({
            message: errorInfo.userMessage,
            type:
              errorInfo.type === 'SERVER_ERROR' ||
              errorInfo.type === 'NETWORK_ERROR'
                ? 'error'
                : 'warning',
          })
        );
      }

      // 커스텀 에러 객체 생성 (호출자가 추가 처리가 필요한 경우를 위해)
      const customError = new Error(errorInfo.userMessage);
      customError.errorInfo = errorInfo;
      customError.shouldShowDialog = errorInfo.type === 'AUTH_ERROR';
      customError.isBusinessError = errorInfo.type === 'BUSINESS_ERROR';

      throw customError;
    };

    const axiosConfig = {
      url: _url,
      method: _type === 'get' ? 'get' : 'post',
    };

    try {
      switch (_type) {
        case 'get':
          return await axios.get(_url, {
            headers: {
              'Content-Type': `application/json`,
              Authorization: 'Bearer ' + token,
            },
            params: _params,
          });
        case 'post':
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `application/json`,
              Authorization: 'Bearer ' + token,
            },
            params: _params,
            ...(_opts?.timeout != null ? { timeout: _opts.timeout } : {}),
          });
        case 'post1': //대용량 데이터 전송시 사용
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `application/json`,
              Authorization: 'Bearer ' + token,
            },
            params: !_bodys ? _params : '',
          });
        case 'file':
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `multipart/form-data`,
              Authorization: 'Bearer ' + token,
            },
            params: !_bodys ? _params : '',
          });
        case 'file2':
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `multipart/form-data`,
            },
            params: !_bodys ? _params : '',
          });
        case 'fileDown':
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `application/json`,
              Authorization: 'Bearer ' + token,
            },
            responseType: 'blob',
            params: _params,
          });
        case 'chunk':
          if (_bodys === null) {
            _bodys = _params;
          }

          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `multipart/form-data`,
              Authorization: 'Bearer ' + token,
            },
            params: !_bodys ? _params : '',
            timeout: 0,
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Chunk upload progress: ${percentCompleted}%`);
            },
          });
        case 'report':
          if (_bodys === null) {
            _bodys = _params;
          }
          return await axios.post(_url, _bodys, {
            headers: {
              'Content-Type': `application/json`,
              Authorization: 'Bearer ' + token,
            },
            responseType: 'blob',
            params: !_bodys ? _params : '',
          });
        case 'login':
          return await axios.post(_url, _params, {
            Headers: {
              headers: { 'Content-Type': `application/json` },
            },
          });
        case 'logout':
          // 로그아웃 API 호출 (Authorization 없이 전송 → 토큰 만료/401 있어도 서버에서 FCM 삭제 가능)
          return await axios.post(_url, _params, {
            headers: { 'Content-Type': 'application/json' },
          });
        default:
          throw new Error(`지원하지 않는 요청 타입: ${_type}`);
      }
    } catch (error) {
      // login과 logout은 에러 처리 제외 (무한 루프 방지)
      if (_type === 'login' || _type === 'logout') {
        throw error;
      }

      if (_opts?.suppressGlobalError && error.response) {
        throw error;
      }

      // 에러 처리 (401은 제외 - 다이얼로그는 호출자가 처리)
      await handleAxiosError(error, { ...axiosConfig, type: _type });
    }
  },

  /**
   * 객체의 모든 값을 EncryptAES로 암호화해서 반환
   * @param {Object} _obj
   * @returns {Object}
   */
  CreateEncryptedParams: (_obj) =>
    Object.fromEntries(
      Object.entries(_obj).map(([key, value]) => [
        key,
        Commons.EncryptAES(value || ''),
      ])
    ),

  /**
   * 단일 요청용 페이로드 생성
   * @param {string} _procedureName
   * @param {Object} _params
   * @returns {Object}
   */
  CreatePayload: (_params) => {
    // const searchInfo = useSelector((state) => state.SearchInfo);
    // // 기본 조회 조건
    // const defaultParams = {
    //   _CUST_CD: searchInfo.custCd,
    //   _START_DATE: searchInfo.startDate,
    //   _END_DATE: searchInfo.endDate,
    //   _SEARCH_TEXT: searchInfo.searchText,
    // };

    // // _params에 따라 조건 설정
    // let paramsToUse = {};

    // switch (_params) {
    //   case 'startEndDate':
    //     paramsToUse = {
    //       _CUST_CD: searchInfo.custCd,
    //       _START_DATE: searchInfo.startDate,
    //       _END_DATE: searchInfo.endDate,
    //       _SEARCH_TEXT: searchInfo.searchText,
    //     };
    //     break;
    //   case 'cust':
    //     paramsToUse = {
    //       _CUST_CD: searchInfo.custCd,
    //     };
    //     break;
    //   default:
    //     paramsToUse = _params || defaultParams; // _params가 falsy한 경우 기본값 사용
    //     break;
    // }

    // return {
    //   procedureName: _procedureName,
    //   ...Commons.CreateEncryptedParams(paramsToUse),
    // };
    return {
      ...Commons.CreateEncryptedParams(_params),
    };
  },

  // Base64 문자열을 Blob으로 변환
  Base64ToBlob: (_base64) => {
    return new Promise((resolve, reject) => {
      const byteCharacters = atob(_base64.split(',')[1]); // Base64 문자열에서 데이터 부분만 추출
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/octet-stream' }); // MIME 타입을 적절히 설정
      resolve(blob);
    });
  },

  // FormData 생성
  GetFormDataPayload: (_data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formList = new FormData(); // FormData 객체 생성

        const blob = await Commons.Base64ToBlob(_data._MAP_BASE64);
        const file = new File([blob], _data._SAVE_NAME, { type: blob.type });

        formList.append('value1', _data._USER_ID); // 사용자 아이디
        formList.append('value2', Commons.EncryptAES(_data._FILE_PATH)); // 암호화된 파일 경로
        formList.append('value3', file); // 파일 객체

        resolve(formList); // FormData 객체 반환
      } catch (error) {
        reject(error); // 에러 발생 시 reject
      }
    });
  },

  // 필수값 유효성 검사
  ValidateRequiredFields: (rows, requiredFields) => {
    for (const row of rows) {
      for (const { field, name } of requiredFields) {
        const value = row[field];
        if (!value || (typeof value === 'string' && value.trim() === '')) {
          return { valid: false, message: `${name} 은(는) 필수입니다.` };
        }
      }
    }
    return { valid: true };
  },

  // URL 인코딩 처리 함수
  EncodeUrl: (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  },
};

export default Commons;
